import React from "react";

interface ProviderProfile {
  firstName: string;
  lastName: string;
  specialty?: string | null;
}

interface NestedProvider {
  id: string;
  provider: {
    id: string;
    email: string;
    providerProfile: ProviderProfile;
  };
}

interface ProviderListProps {
  providers: NestedProvider[];
}

const ProviderList: React.FC<ProviderListProps> = ({ providers }) => {
  if (providers.length === 0) {
    return <p className="no-providers">No providers found for this clinic.</p>;
  }

  return (
    <div className="provider-list-container">
      <h2 className="provider-list-title">Clinic Providers</h2>
      <table className="provider-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Specialty</th>
          </tr>
        </thead>
        <tbody>
          {providers.map(({ id, provider }) => (
            <tr key={id}>
              <td>
                {provider.providerProfile.firstName}{" "}
                {provider.providerProfile.lastName}
              </td>
              <td>{provider.email}</td>
              <td>{provider.providerProfile.specialty || "N/A"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProviderList;
